module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a23ddf472c2139e0c0361f74eb4da16e.png";